import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addSingleNotification, notificationList } from "../apis/apiHandler";

export const notifications = createAsyncThunk(
    "notification/list",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await notificationList(payload);

            if (response?.code === 200 || response?.code === 404) {
                return response.data;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addNotification = createAsyncThunk(
    "notification/add",
    async ({ payload }, { rejectWithValue }) => {
        console.log('payloaddd: ', payload);
        try {
            const response = await addSingleNotification(payload);

            if (response?.code === 200) {
                return response;
            } else {
                return rejectWithValue(response);
            }
        } catch (err) {
            console.log("err: ", err);
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const initialState = {
    loading: false,
    notificationList: [],
    addNotificationData: {},
    error: null,
    success: false,
};

const notificationSlice = createSlice({
    name: "notification",
    initialState,

    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(notifications.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(notifications.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.notificationList = payload;
                state.success = true;
            })
            .addCase(notifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
            .addCase(addNotification.pending, (state) => {
                state.loading = true;
                state.error = null; // Reset error on new request
                state.success = false; // Reset success on new request
            })
            .addCase(addNotification.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.addNotificationData = payload;
                state.success = true;
            })
            .addCase(addNotification.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.success = false;
            })
    },
});

export default notificationSlice.reducer;
